<template>
    <el-dialog
        :modal="false"
        :close-on-click-modal="false"
        custom-class="complaint-wrap"
        title="服务投诉"
        :visible.sync="dialogVisible"
        width="410px"
        :before-close="handleClose"
    >
        <div class="head">反馈您所遇到的情况，我们将尽快与您联系核实</div>
        <el-form ref="form" :model="form" :rules="rules" label-width="80px">
            <el-form-item label="投诉对象" prop="complaintObjectType">
                <el-select popper-class="complaint-select" v-model="form.complaintObjectType" placeholder="请选择投诉对象">
                    <el-option label="顾问" value="1"></el-option>
                    <el-option label="客服" value="2"></el-option>
                    <el-option label="其他" value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="投诉内容" prop="complaintContent">
                <el-input type="textarea" rows="4" placeholder="请简述情况，最多150字" v-model="form.complaintContent"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="contactPhone">
                <el-input v-model="form.contactPhone" placeholder="请填写11位手机号"></el-input>
            </el-form-item>
        </el-form>
        <span slot="title" class="dialog-title">
            <img class="complaint-icon" src="https://imagecdn.ymm56.com/ymmfile/static/image/complaint.png" />
            <span class="complaint-title">服务投诉</span>
        </span>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">放弃</el-button>
            <el-button type="primary" @click="confirm">发送</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { debounce } from 'lodash'

export default {
    data() {
        return {
            dialogVisible: false, // 显隐判断
            phone: '', // 联系电话取值
            form: {
                complaintObjectType: '', // 投诉对象
                complaintContent: '', // 投诉内容
                contactPhone: '' // 联系电话
            },
            rules: {
                complaintObjectType: [{ required: true, message: '请选择投诉对象', trigger: 'change' }],
                complaintContent: [{ required: true, message: '请填写投诉内容', trigger: 'change' }],
                contactPhone: [
                    { required: true, message: '请检查联系方式', trigger: 'change' },
                    { validator: this.validatePhone, trigger: 'change' }
                ]
            }
        }
    },
    mounted() {
        // 获取联系电话
    },
    methods: {
        show() {
            const that = this
            this.dialogVisible = true
            this.getTelConfig()
            this.$nextTick(() => {
                that.getIntentionalForm()
            })
            setTimeout(() => {
                $('.complaint-wrap').parent().css('z-index', 10002)
            }, 0)
        },
        getTelConfig() {
            // 获取操作员手机号
            $.newAjax({
                data: { userid: getNewUserInfo().UserId, LoginSite: '', LoginUserId: '', LoginUserName: '' },
                procParams: {
                    M: 'Query',
                    N: 'QSP_GET_USERS_BY_ID'
                },
                async: false,
                type: 'POST',
                dataType: 'json',
                success: result => {
                    if (result.Success) {
                        var data = result.data.Table1.length ? result.data.Table1[0] : {}
                        if (data.userphone) {
                            this.phone = String(data.userphone)
                        }
                    }
                }
            })
        },
        getIntentionalForm() {
            this.form.contactPhone = this.phone
        },
        validatePhone(rule, value, callback) {
            // const reg_tel = /^(0\d{2,3}-?)\d{7,8}$/;
            const reg_celltel = /^(1)\d{10}$/
            if (!value) {
                callback()
                // } else if (!reg_celltel.test(value) && !reg_tel.test(value)) {
            } else if (!reg_celltel.test(value)) {
                callback(new Error('请检查联系方式'))
            } else {
                callback()
            }
        },
        confirm: debounce(
            function () {
                const complaintContent = this.form.complaintContent.trim()
                const complaintObjectType = Number(this.form.complaintObjectType)
                this.$refs.form.validate(valid => {
                    if (valid) {
                        if (complaintContent.length > 150) {
                            showMsg({
                                content: '投诉内容最多输入150字！'
                            })
                            // ShowERR('投诉内容最多输入150字！')
                            return
                        }
                        // 走接口请求
                        $.javaAjax({
                            url: '/web/feedback/complaint',
                            type: 'POST',
                            async: false,
                            useCustomError: true,
                            data: {
                                ...this.form,
                                complaintContent,
                                complaintObjectType
                            },
                            success: res => {
                                if (res && res.success && res.data && res.data.complaintSuccess) {
                                    showMsg({
                                        content: '投诉已发送！'
                                    })
                                    this.handleClose()
                                } else {
                                    showMsg({
                                        content: res.data.failTips
                                    })
                                }
                            },
                            error: res => {
                                showMsg({
                                    content: JSON.parse(res.responseText || '{}').message
                                })
                            }
                        })
                        // 服务投诉埋点点击
                        window.lib && window.lib.track.tap('send_complaint', 'Main', {
                            pageName: 'lanqiao_saas_home',
                        })
                    }
                })
            },
            500,
            {
                leading: true,
                trailing: false
            }
        ),
        handleClose() {
            this.$refs.form.resetFields()
            this.form.complaintObjectType = ''
            this.form.complaintContent = ''
            this.form.contactPhone = ''
            this.dialogVisible = false
        }
    }
}
</script>

<style lang="scss">
.complaint-wrap {
    border-radius: 20px;
    background: #f2f2f2;

    .head {
        font-size: 16px;
        font-weight: 500;
        line-height: normal;
        color: #1a1a1a;
        margin-bottom: 18px;
    }

    .dialog-title {
        display: flex;
    }

    .complaint-icon {
        width: 24px;
        margin-right: 20px;
    }

    .el-dialog__header {
        background: #304554;
        border-radius: 20px 20px 0 0;
    }

    .complaint-title {
        color: #fff;
        font-size: 16px;
        font-weight: normal;
    }

    .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 22px;
        font-weight: bold;
    }

    .el-form-item__label {
        color: #161616;
    }

    .el-select input[readonly='readonly'] {
        background: #fff;
    }

    .el-select {
        display: block;
    }

    .el-dialog__footer {
        text-align: center;
    }

    .el-button--default {
        border-color: #304554;
        color: #304554;
        background: #f2f2f2;
    }

    .el-button--primary {
        background: #304554;
        font-size: 14px;
        font-weight: normal;
        color: #ffffff;
        border-color: transparent;
    }

    .el-dialog__body {
        padding: 30px 20px 0;
    }
}
.complaint-select {
    z-index: 10002 !important;
}
</style>
